export default __webpack_public_path__ + "static/media/grua_pluma_5.06032597.png";